const VideoTypes = {
    MP4: 'mp4',
    MOV: 'mov',
    GIF: 'gif',
};

export const SupportedVideoTypes = [VideoTypes.GIF, VideoTypes.MOV, VideoTypes.MP4];
export default VideoTypes;
